/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_uc_len_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How many centimeters are in an inch?`)
};

const es_uc_len_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Cuántos centímetros hay en una pulgada?`)
};

const de_uc_len_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wie viele Zentimeter hat ein Zoll?`)
};

const nl_uc_len_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hoeveel centimeters zitten in een inch?`)
};

const fr_uc_len_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Combien de centimètres sont dans un pouce ?`)
};

const it_uc_len_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quanti centimetri ci sono in un pollice?`)
};

const pt_br2_uc_len_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quantos centímetros tem em uma polegada?`)
};

const pt_uc_len_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quantos centímetros existem numa polegada?`)
};

const ja_uc_len_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1インチには何センチメートルありますか?`)
};

const zh_uc_len_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`[pending translation]`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const uc_len_faq1_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.uc_len_faq1_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("uc_len_faq1_q", locale)
	if (locale === "en") return en_uc_len_faq1_q(inputs)
	if (locale === "es") return es_uc_len_faq1_q(inputs)
	if (locale === "de") return de_uc_len_faq1_q(inputs)
	if (locale === "nl") return nl_uc_len_faq1_q(inputs)
	if (locale === "fr") return fr_uc_len_faq1_q(inputs)
	if (locale === "it") return it_uc_len_faq1_q(inputs)
	if (locale === "pt-BR") return pt_br2_uc_len_faq1_q(inputs)
	if (locale === "pt") return pt_uc_len_faq1_q(inputs)
	if (locale === "ja") return ja_uc_len_faq1_q(inputs)
	return zh_uc_len_faq1_q(inputs)
};